// prettier-ignore
export default "2025.0530.1024"